import { useTabsNavigation } from "components/base/Tabs";
import { Title } from "../../components/base/Title";

export default function CGV() {
  const { switchToTab } = useTabsNavigation();

  const handleLinkClick = (tabIndex: number) => {
    switchToTab(tabIndex);
  };
  
  return (
    <div className="p-6 max-w-4xl mx-auto leading-relaxed">
      <Title type="subdisplay" centered>Conditions Générales de Vente</Title>
      <p className="text-gray-600 mb-6 text-center">
        <strong>Dernière mise à jour :</strong> 18 octobre 2025
      </p>

      <div className="space-y-8">
        <section>
          <p className="mb-4">
            Les présentes Conditions Générales de Vente (CGV) régissent les ventes de produits apicoles 
            effectuées par Carole et Sylvain LEBAS, apiculteurs producteurs et récoltants à Torcy-Le-Grand, 
            via la plateforme "Le Rucher de Carole et Sylvain". En passant commande, vous acceptez pleinement ces conditions.
          </p>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            1. Informations sur le vendeur
          </Title>

          <div className="border border-gray-200 rounded-lg p-4">
            <Title type="h3" className="font-semibold mb-2">Vendeur</Title>
            <p><strong>Nom :</strong> Carole et Sylvain LEBAS</p>
            <p><strong>Activité :</strong> Apiculteurs producteurs et récoltants</p>
            <p><strong>Localisation :</strong> Torcy-Le-Grand, Normandie</p>
            <p><strong>Produits :</strong> Miel et produits de la ruche</p>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            2. Produits proposés
          </Title>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Catalogue</Title>
              <p>
                Nous proposons exclusivement des produits apicoles naturels issus de notre production locale :
              </p>
              <ul className="list-disc list-inside space-y-1 text-gray-700 mt-2">
                <li>Miel de printemps (500g et 1kg)</li>
                <li>Miel d'été (500g et 1kg)</li>
              </ul>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Caractéristiques</Title>
              <p>
                Tous nos produits sont naturels, sans ajouts, et issus de notre production apicole locale. 
                La qualité et la disponibilité dépendent des récoltes et des conditions climatiques.
              </p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            3. Commandes
          </Title>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Processus de commande</Title>
              <ol className="list-decimal list-inside space-y-1 text-gray-700">
                <li>Sélection des produits dans le catalogue</li>
                <li>Ajout au panier et vérification des quantités</li>
                <li>Validation du panier et acceptation des CGV</li>
                <li>Paiement sécurisé via Stripe</li>
                <li>Confirmation de commande par email</li>
              </ol>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Acceptation de la commande</Title>
              <p>
              Toute commande payée vous sera confirmée par le Rucher de Carole et Sylvain par email.
              </p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            4. Prix et modalités de paiement
          </Title>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Prix</Title>
              <p>
                Les prix sont indiqués en euros TTC. En tant qu'apiculteurs, nous ne sommes pas soumis à la TVA 
                (article 293B du CGI). Les prix applicables sont ceux en vigueur au moment de la commande.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Paiement</Title>
              <p>
                Le paiement s'effectue exclusivement en ligne via la plateforme Stripe, garantissant 
                la sécurité des transactions. Les moyens de paiement acceptés sont : cartes bancaires
                et PayPal proposés par Stripe.
              </p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            5. Livraisons
          </Title>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Système de livraison groupée</Title>
              <p>
                Les livraisons sont organisées par zones géographiques et par périodes définies 
                pour optimiser les coûts et l'impact environnemental. Les clients sont informés 
                des dates de livraison lors de la commande.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Délais de livraison</Title>
              <p>
                Les délais de livraison sont indiqués lors de la commande et dépendent de la zone 
                géographique et de la période de livraison choisie. En cas de retard, le client 
                sera informé dans les meilleurs délais.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Réception des produits</Title>
              <p>
                Le client s'engage à être présent aux dates et lieux de livraison convenus. 
                En cas d'absence, les produits seront conservés selon les modalités définies 
                pour chaque zone de livraison.
              </p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            6. Disponibilité et rupture de stock
          </Title>

          <div className="border border-gray-200 rounded-lg p-4">
            <p>
              La disponibilité des produits varie selon les récoltes et les conditions de production. 
              En cas de rupture de stock, le client ne pourra pas commander le produit concerné 
              jusqu'à la prochaine récolte. Le vendeur se réserve le droit de limiter les quantités 
              par commande pour assurer une répartition équitable.
            </p>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            7. Droit de rétractation
          </Title>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Limitation du droit de rétractation</Title>
              <p>
                Conformément à l'article L. 221-28 du Code de la consommation, le droit de rétractation 
                ne s'applique pas aux contrats de fourniture de denrées alimentaires. Les produits apicoles 
                (miel, pollen, etc.) étant des denrées alimentaires, le droit de rétractation ne s'applique pas.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Cas particuliers</Title>
              <p>
                En cas de problème avec un produit (qualité, conformité, casse lors du transport), 
                le client peut contacter le service client pour une solution adaptée (remplacement, 
                remboursement partiel ou total selon le cas).
              </p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            8. Garanties et responsabilités
          </Title>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Garantie de qualité</Title>
              <p>
                Nous garantissons la qualité naturelle de nos produits apicoles. En cas de non-conformité 
                avérée, nous nous engageons à remplacer le produit ou à rembourser le client.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Force majeure</Title>
              <p>
                Le vendeur ne pourra être tenu responsable de l'inexécution de ses obligations en cas 
                de force majeure, notamment : conditions climatiques défavorables, problèmes de production 
                apicole, événements extérieurs affectant la récolte.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Conservation des produits</Title>
              <p>
                Le client s'engage à conserver les produits dans des conditions appropriées (température, 
                humidité) pour maintenir leur qualité. Les conseils de conservation sont fournis avec 
                chaque commande.
              </p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            9. Protection des données personnelles
          </Title>

          <div className="border border-gray-200 rounded-lg p-4">
            <p>
              Le traitement des données personnelles est régi par notre 
              <button 
                onClick={() => handleLinkClick(2)} 
                className="text-primary-600 hover:underline ml-1 cursor-pointer"
              >
                politique de confidentialité
              </button>. 
              Les données collectées sont nécessaires au traitement des commandes et à l'organisation 
              des livraisons.
            </p>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            10. Droit applicable et juridiction
          </Title>

          <div className="space-y-4">
            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Droit applicable</Title>
              <p>
                Les présentes CGV sont soumises au droit français. En cas de conflit entre les versions 
                en différentes langues, la version française prévaut.
              </p>
            </div>

            <div className="border border-gray-200 rounded-lg p-4">
              <Title type="h3" className="font-semibold mb-2">Juridiction compétente</Title>
              <p>
                En cas de litige, les tribunaux français seront seuls compétents.
              </p>
            </div>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            11. Contact et réclamations
          </Title>

          <div className="border border-gray-200 rounded-lg p-4">
            <p>
              Pour toute question, réclamation ou demande d'information concernant ces CGV ou vos commandes :
            </p>
            <p className="mt-2">
              <strong>Contact :</strong> Via la plateforme ou les coordonnées fournies lors de la commande
            </p>
            <p>
              <strong>Médiation :</strong> En cas de litige non résolu à l'amiable, le client peut recourir 
              à la médiation de la consommation conformément aux dispositions du Code de la consommation.
            </p>
          </div>
        </section>

        <section>
          <Title type="h2" className="font-semibold mb-4 text-primary-600">
            12. Modifications des CGV
          </Title>

          <div className="border border-gray-200 rounded-lg p-4">
            <p>
              Le vendeur se réserve le droit de modifier les présentes CGV à tout moment. 
              Les modifications entrent en vigueur dès leur publication sur la plateforme. 
              Les commandes en cours restent soumises aux CGV en vigueur au moment de leur passation.
            </p>
            <p className="mt-4">
              Nous vous encourageons à consulter régulièrement cette page pour prendre connaissance 
              des éventuelles modifications.
            </p>
          </div>
        </section>
      </div>
    </div>
  );
}